export default "__VITE_ASSET__vDPLochu__"